export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api"
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || "http://localhost:4000/"
export const FRONTEND_URL = process.env.FRONTEND_URL || "http://localhost:3000/"